'use client';
import { useState } from 'react';
import { Story } from '@/lib/types';

interface BreakingStripProps {
  stories?: Story[];
}

const FALLBACK_TEXT = 'UN Security Council convenes emergency session · Federal Reserve signals rate pause as inflation nears 2% target · California wildfires force 80,000 evacuations · ';

export default function BreakingStrip({ stories }: BreakingStripProps) {
  const [paused, setPaused] = useState(false);

  const tickerContent = stories && stories.length > 0 
    ? stories.map(s => s.title).join(' · ') + ' · '
    : FALLBACK_TEXT;

  return (
    <div className="bg-[#C8102E] h-[38px] flex items-center overflow-hidden w-full">
      <div className="bg-[#9E0C23] text-white font-['IBM_Plex_Sans',system-ui,sans-serif] font-extrabold text-[11px] tracking-[0.1em] uppercase px-4 h-full flex items-center shrink-0 z-10">
        BREAKING
      </div>
      <div
        className="flex-1 overflow-hidden"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <div
          className={`flex whitespace-nowrap ${paused ? 'animate-ticker-paused' : 'animate-ticker'}`}
          style={{
            animationDuration: stories && stories.length > 0 ? `${tickerContent.length / 5}s` : '35s',
            animationTimingFunction: 'linear',
            animationIterationCount: 'infinite',
            animationPlayState: paused ? 'paused' : 'running',
          }}
        >
          <span className="text-white font-['IBM_Plex_Sans',system-ui,sans-serif] text-[12px] tracking-[0.01em] pr-8">
            {tickerContent}{tickerContent}
          </span>
        </div>
      </div>
    </div>
  );
}
